import clsx from "clsx";
import { observer } from "mobx-react-lite";
import React from "react";
import Media from "../Media/Media";
import classes from "./SwipeRecap.module.css";
import Catalogue from "@/js/Catalogue/Catalogue";

const SwipeRecap = ({instance}) => {
  return (
    <div className={classes.SwipeRecap}>

      {instance.Propositions.map(p => {

        if (p.catalogId) {
          let catItem = Catalogue.get(p.catalogId);
          if (catItem) {
            if(!p.userIsCorrect)
              catItem.knowledge = -1;
            else
              catItem.knowledge = 1;
          }
        }

        return (
        <div className={classes.proposition_recap} key={p.ID}>
            {p.media &&
            <div className={classes.media_ctnr}>
              <Media path={p.media} root="data/" />
            </div>}

          <div className={classes.texts}>
            {p.Text &&
            <div className={classes.text}>{p.Text}</div>}

            {p.Debrief &&
            <div className={classes.minidebrief}>{p.Debrief}</div>}

          </div>
          <div className={classes.answers}>

            <div className={clsx(
              classes.choice,
              !p.isCorrect && p.userIsCorrect && classes.correctChoice,
              !p.isCorrect && !p.userIsCorrect && classes.missedChoice,
              p.isCorrect && !p.userIsCorrect && classes.incorrectChoice,
            )}>

              {p.incorrectText}

              {/* <div className={classes.pawns}>
                {p.userAnswer === false && <BsFillSuitDiamondFill style={{color: AppState.plateau.myPlayer.Color}} />}
              </div> */}
            </div>


            <div className={clsx(
              classes.choice,
              p.isCorrect && p.userIsCorrect && classes.correctChoice,
              p.isCorrect && !p.userIsCorrect && classes.missedChoice,
              !p.isCorrect && !p.userIsCorrect && classes.incorrectChoice,
            )}>
              {p.correctText}
              {/* <div className={classes.pawns}>
                {p.userAnswer === true && <BsFillSuitDiamondFill style={{color: AppState.plateau.myPlayer.Color}} />}
              </div> */}
            </div>

          </div>
        </div>)
      })}



    </div>
  )
}

export default observer(SwipeRecap)